import { EnvironmentProviders, inject, provideAppInitializer } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import posthog from "posthog-js";
import { filter } from "rxjs/operators";

export function providePostHogPageviewTracking(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const router = inject(Router);
    router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(() => {
      posthog.capture("$pageview");
    });
  });
}
